/**
 * Deze klasse handelt het tonen van de instructie van een groep af
 *
 * @history
 * 16 juni 2023
 *
 * Start implementatie
 *
 */

import React from "react";
import {Popup} from "../containers/Popup";
import {FormSelect} from "../helpers/FormSelect";
import {DraggablePupil} from "../helpers/DraggablePupil";
import {FormPopup} from "../containers/FormPopup";

export class GroupInstruction extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state =
            {
                show_err: false,
                err_message: "",


            }

        this.icons_urls=
            [
                "/digibord/assets/svgs/icons/Bakje_cirkel.svg",
                "/digibord/assets/svgs/icons/Groep_cirkel.svg",
                "/digibord/assets/svgs/icons/Lijm_cirkel.svg",
                "/digibord/assets/svgs/icons/Lineaal_cirkel.svg",
                "/digibord/assets/svgs/icons/Oor_cirkel.svg",
                "/digibord/assets/svgs/icons/Papier_cirkel.svg",
                "/digibord/assets/svgs/icons/Potlood_cirkel.svg",
                "/digibord/assets/svgs/icons/Praten_cirkel.svg",
                "/digibord/assets/svgs/icons/Samenwerken_cirkel.svg",
                "/digibord/assets/svgs/icons/Schaar_cirkel.svg",
                "/digibord/assets/svgs/icons/Uiltje_cirkel.svg",
                "/digibord/assets/svgs/icons/Vergrootglas_cirkel.svg",
            ];

        this.icons =  (props.icons === "" ?  [] : props.icons.split(",").map(Number));

        this.icons.sort((a, b) => a - b);
    }

    render()
    {
        return (
            <FormPopup has_close_btn={true} title={"Groeps gegevens"} callback={this.props.callback}>
                <h1>{this.props.location}</h1>
                <div style={{"float": "left", "width": "45%"}}>
                    <h2>Instructie</h2>
                    <p>{this.props.instruction}</p>

                    <p>
                    {this.icons.map(( icon_index) =>
                        (
                            <img src={this.icons_urls[icon_index]}  key={icon_index}
                                 style={{
                                     "border-radius":"125px",
                                     "width":"125px",
                                     "margin":"4px"
                                 }}
                            />
                        )
                    )
                    }
                    </p>




                    {this.props.has_image && (
                        <img src={this.props.image_url}
                             style={{"max-height": "300px", "width": "auto", "margin-top": "5px"}}
                        />

                    )}

                    {this.props.has_audio && (
                        <audio controls src={this.props.audio_url}>

                        </audio>
                    )}
                </div>
                <div style={{"float": "left", "margin-left": "16px", "width": "45%"}}>
                    {this.props.pupils.map((pupil, pupil_index) =>
                        (
                            <div style={{
                                width: "75px",
                                height: "75px",
                                "margin-left": "5px",
                                "margin-bottom": "2px",
                                float: "left",
                                border: "1px solid #000"
                            }}>
                                <div className={"draggable_pupil"}
                                     style={pupil.has_image == "Y" ? {
                                         "background-image": "url('" + pupil.image_url + "')",
                                         "background-size": "contain"
                                     } : {}}>
                                    <div
                                        className={"draggable_pupil_name"}>{pupil.name}</div>
                                </div>
                            </div>


                        ))
                    }
                </div>

            </FormPopup>

        );
    }

}
